import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "./base-component";

function GuestRoute ({ component: Component, title, ...rest }) {
  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout || ((page) => page);
  const appWithLayout = getLayout(<Component {...rest} />);

  const BaseComponentWrappedApp = (
      <BaseComponent component={() => appWithLayout} />
  );

  return (
      BaseComponentWrappedApp
  )
}

GuestRoute.displayName = 'Guest Route';

GuestRoute.propTypes = {
  component: PropTypes.func.isRequired,
  rest: PropTypes.object,
  location: PropTypes.object,
  title: PropTypes.string
};

export default GuestRoute;
